export function richTextModule(item)
{ 
  const richTextModule = `
    <div class="col-span-12 prose mb-7" data-component="rich-text">
      ${item.properties.richText.markup}
    </div>
  `;
  return richTextModule;
}
